import React from 'react';

export const FiltersIcon = ({
  width,
  height,
  className,
  fill = '#E1F4D3',
  stroke = '#1C452B',
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_54_89)">
        <mask id="mask0_54_89" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="61" height="61">
          <path d="M60.7475 0H0V60.7475H60.7475V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_54_89)">
          <path d="M13.8059 24.8512L26.2316 6.90308H11.0447L9.66406 9.66432V17.9481L13.8059 24.8512Z" fill={fill} />
          <path fill="none" d="M13.6682 5.31445H47.0793C49.8636 5.31445 52.1416 7.59248 52.1416 10.3767V15.9453C52.1416 17.9702 50.876 20.5013 49.6104 21.7669L38.7265 31.3852C37.2078 32.6508 36.1954 35.1819 36.1954 37.2068V48.0908C36.1954 49.6095 35.1829 51.6344 33.9173 52.3937L30.3737 54.6717C27.0833 56.6967 22.5272 54.4186 22.5272 50.3688V36.9537C22.5272 35.1819 21.5148 32.9039 20.5023 31.6383L10.884 21.5138C9.61842 20.2482 8.60596 17.9702 8.60596 16.4515V10.6299C8.60596 7.59248 10.884 5.31445 13.6682 5.31445Z" stroke={stroke} strokeWidth="3.79672" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path fill="none" d="M27.6651 5.31445L15.1865 25.3105" stroke={stroke} strokeWidth="3.79672" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_54_89">
          <rect width="60.7475" height="60.7475" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
};
